<h6 class="title" tnTestId="loader-title" tnTestIdType="text">{{ title() | translate }}</h6>
<div class="spinner-container">
  <tn-spinner mode="indeterminate" [ariaLabel]="title() | translate"></tn-spinner>
</div>
